import { signUp } from "aws-amplify/auth";
import { RegisterSchema } from "@validators/auth";
import { authBus } from "../AuthEvents";

export const register = async ({ email, password }: RegisterSchema) => {
  try {
    // 1. Modern functional API call
    const { nextStep } = await signUp({
      username: email, // Assuming email is used as the username
      password,
      options: {
        userAttributes: {
          email,
        },
      },
    });

    // 3. Handle success flow
    if (nextStep.signUpStep === "CONFIRM_SIGN_UP") {
      authBus.emitMessage("Account created! Please check your email for a verification code.", "success");
      authBus.emitTransition("get-email-confirmation");
      if (typeof window !== "undefined") (window as any)?.plausible?.("User-Register");
    }
  } catch (error: any) {
    let userMessage = "An error occurred during registration. Please try again.";

    switch (error.name) {
      case "UsernameExistsException":
        userMessage = "An account already exists with this email.";
        break;
      case "InvalidPasswordException":
        userMessage = "Password does not meet requirements.";
        break;
      case "CodeDeliveryFailureException":
        userMessage = "We couldn't send the code. Please check your email address.";
        break;
      case "LimitExceededException":
      case "TooManyRequestsException":
        userMessage = "Too many requests. Please try again in a few minutes.";
        break;
      default:
        userMessage = error.message || userMessage;
        break;
    }

    authBus.emitMessage(userMessage, "error");
  }
};
